import {
  ItemWrapper,
  ContentWrapper,
  Error,
  InputWrapper,
  ButtonsWrapper,
  NotificationWrapper,
} from "../../styles";
import { useAppDispatch, useAppSelector } from "../../../../../../../app/hooks";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { Input } from "../../../../../../../components/common/Input";
import { InputPhone } from "../../../../../../../components/common/InputPhone";
import { Button } from "../../../../../../../components/common/Button";
import { savedCNYData } from "../../../../../redux/formDataSlice";
import { fetchCNYCardBank } from "../../../../../redux/slice";
import CustomSelect from "../../../../../../../components/common/CustomSelect";
import React, { useEffect, useState } from "react";
import { ReactComponent as InfoIcon } from "../../../../../../../assets/icons/info.svg";

import {
  CNYProps,
  FormInputs,
  UserData,
} from "../../../../../../../types/walletTypes";
import Loader from "../../../../../../../components/common/Loader";

const UnionPayPaymentDetailsForm = ({
  handleNext,
  handlePrevious,
}: CNYProps) => {
  const dispatch = useAppDispatch();
  const getSavedData = useAppSelector((state) => state.formData.cnyData);
  const { keys } = useAppSelector((state) => state.settings);
  const { businessId } = useAppSelector((state) => state.users);
  const { loading } = useAppSelector((state) => state?.wallets || {});

  const [userData, setUserData] = useState<UserData | null>(getSavedData);

  const handleDataUpdate = (field: keyof UserData, value: any) => {
    setUserData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm<FormInputs>({ defaultValues: getSavedData || {} });

  useEffect(() => {
    if (businessId) {
      dispatch(
        fetchCNYCardBank({
          xAuthToken: keys?.data?.publicKey,
          includeType: !getSavedData.accountType,
        }),
      ).then((action) => {
        if (fetchCNYCardBank.fulfilled.match(action)) {
          const uniqueBanks = Array.from(
            new Map(
              action.payload.data.map((bank: any) => [bank.code, bank]),
            ).values(),
          );

          handleDataUpdate("banks", uniqueBanks);
        }
      });
    }
  }, [businessId]);

  const formatCreditCardNumber = (value: string) => {
    const numericValue = value.replace(/\D/g, "");
    const formattedValue = numericValue.replace(/(\d{4})(?=\d)/g, "$1 ");
    return formattedValue.trim();
  };

  const onSubmit: SubmitHandler<FormInputs> = (data) => {
    dispatch(savedCNYData(data));
    handleNext?.();
  };

  const bankOptions = userData?.banks?.map((bank) => ({
    value: bank.code,
    label: bank.name,
  }));

  return (
    <ContentWrapper>
      <Loader isLoading={loading} />
      <InputWrapper>
        <Controller
          name="bankCode"
          control={control}
          rules={{ required: "Bank is required" }}
          render={({ field }) => (
            <CustomSelect
              value={field.value}
              options={bankOptions}
              onChange={(selectedValue) => {
                field.onChange(selectedValue);
                const selectedBank = userData?.banks?.find(
                  (b) => b.code === selectedValue,
                );
                setValue("bankName", selectedBank?.name || "");
              }}
              $width="100%"
              placeholder="Bank name"
              showSearch
              filterOption={(inputValue, option) =>
                option.label.toLowerCase().includes(inputValue.toLowerCase())
              }
              lightBorder
            />
          )}
        />
        <Error>{errors?.bankCode?.message}</Error>
      </InputWrapper>

      <ItemWrapper>
        <InputWrapper>
          <Controller
            name="accountName.firstName"
            control={control}
            rules={{ required: "Field is required" }}
            render={({ field }) => (
              <Input
                type="text"
                label="Account first name"
                value={field.value}
                onChange={field.onChange}
                hasError={!!errors?.accountName?.firstName}
                labelColor="#FFFFFF"
              />
            )}
          />
          <NotificationWrapper>
            <InfoIcon />
            <p>The name must be in Chinese</p>
          </NotificationWrapper>

          <Error>{errors?.accountName?.firstName?.message}</Error>
        </InputWrapper>

        <InputWrapper>
          <Controller
            name="accountName.lastName"
            control={control}
            rules={{ required: "Field is required" }}
            render={({ field }) => (
              <Input
                type="text"
                label="Account last name"
                value={field.value}
                onChange={field.onChange}
                hasError={!!errors?.accountName?.lastName}
                labelColor="#FFFFFF"
              />
            )}
          />
          <NotificationWrapper>
            <InfoIcon />
            <p>The name must be in Chinese</p>
          </NotificationWrapper>
          <Error>{errors?.accountName?.lastName?.message}</Error>
        </InputWrapper>
      </ItemWrapper>

      <InputWrapper>
        <Controller
          name="receiverMobileNumber"
          control={control}
          rules={{ required: "Phone number is required" }}
          render={({ field }) => (
            <InputPhone
              label="Phone number"
              field={field}
              defaultCountry="CN"
            />
          )}
        />
        <Error>{errors?.receiverMobileNumber?.message}</Error>
      </InputWrapper>

      <ButtonsWrapper>
        <Button
          onClick={handlePrevious}
          label="Back"
          height="48px"
          theme="alternate"
          width="203px"
        />
        <Button
          onClick={handleSubmit(onSubmit)}
          label="Continue"
          height="48px"
        />
      </ButtonsWrapper>
    </ContentWrapper>
  );
};

export default UnionPayPaymentDetailsForm;
